import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

import { canSeeFakt } from "helpers/helpers";
import { getFirstMenuUrl, isMenuPathAllowed, matchPath } from "components/VerticalLayout/menues";

// Pages a read-only ROLE_ANALYTIC user is allowed to open (matched by prefix).
const ANALYTIC_ALLOWED_PATHS = ["/dashboard", "/admin/clients", "/pos", "/admin/debt/excel"];
const FAKT_PATH = "/fakt";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !localStorage.getItem("authUser")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      // The checks below run only on protected routes and only once authenticated.
      // Running them on public routes (e.g. /login) would bounce the login page and
      // create a redirect loop.
      if (isAuthProtected && localStorage.getItem("authUser")) {
        const path = props.location.pathname;

        // Menyusida yo'q sahifa (masalan Dashboard yoki Plan) URL orqali ham
        // ochilmasin — foydalanuvchi o'zining birinchi sahifasiga qaytariladi.
        if (!isMenuPathAllowed(path)) {
          return <Redirect to={{ pathname: getFirstMenuUrl() }} />;
        }

        // Restrict read-only ROLE_ANALYTIC users to their allowed pages.
        if (localStorage.getItem("role") === "ROLE_ANALYTIC") {
          // Ruxsat berilgan loginlar uchun Fakt sahifasi ham ochiq
          const allowedPaths = canSeeFakt() ? [...ANALYTIC_ALLOWED_PATHS, FAKT_PATH] : ANALYTIC_ALLOWED_PATHS;
          if (!allowedPaths.some(p => matchPath(path, p))) {
            return <Redirect to={{ pathname: "/dashboard" }} />;
          }
        }
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
);

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
};

export default Authmiddleware;
